<template>
  <x-page title="抵扣结果" white-background>
    <div :class="_.status">
      <img :class="_.img" src="./images/success.png" alt="" />
      <div :class="_.text">抵扣成功</div>
      <div :class="_.price">
        已成功抵扣 <span>¥{{ queryParams.payPoint }}</span> 元消费金
      </div>
    </div>
    <!-- <div v-if="queryParams.payAmt > 0" :class="_.main">
      <div :class="_.tips">
        您还剩 <span>￥{{ queryParams.payAmt }}元</span> 订单余额未支付
      </div>
      <div :class="_.time">
        将在
        <van-count-down :time="time" format="ss" @finish="goBack" />s后自动返回订单结算页
      </div>
      <div :class="_.btn" @click="goPay">￥{{ queryParams.payAmt }} 立即去支付</div>
    </div>
    <div v-else :class="_.back" @click="goBack">返回订单页</div> -->

    <van-popup v-model="show" round>
      <div :class="_.popup">
        <div :class="_.step">
          <img src="./images/finish.png" alt="" />
          <div :class="_.desc">
            <p :class="_.totalPrice">
              订单总金额为<span>￥{{ queryParams.totalAmt }}元</span>
            </p>
            <p :class="_.payAmt">消费金已抵扣{{ queryParams.payPoint }}元</p>
          </div>
        </div>
        <div :class="[_.step, _.step1]">
          <img src="./images/pass.png" alt="" />
          <div :class="_.desc">
            <p :class="_.surPrice">
              您还需支付<span>￥{{ queryParams.payAmt }}元</span>
            </p>
            <p :class="_.payAmt">订单剩余金额未支付</p>
          </div>
        </div>
        <div :class="_.pay" @click="goPay">去支付</div>
        <div :class="_.order" @click="goBack">查看订单</div>
      </div>
    </van-popup>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { apiOrderOrderPay } from '@/api'
  import { dcb } from '@dcb/jssdk'
  import { globalModel } from '@/model'
  import { navigateBack, redirectTo } from '@/router'
  import { submit, Track } from '@/utils'
  import { wait } from 'vtils'
  export default Vue.extend({
    noKeepalive: true,

    mixins: [
      Track.provideMark(() => ({
        page: '支付结果',
      })),
    ],

    data() {
      return {
        time: 60 * 1000,
        show: false,
        queryParams: {
          orderNo: '',
          payAmt: '',
          totalAmt: '',
          payPoint: '',
        },
      }
    },
    created() {
      this.$nextTick(() => {
        const { orderNo, payAmt, totalAmt, payPoint } = this.$route.query
        this.queryParams = {
          orderNo,
          payAmt,
          totalAmt,
          payPoint,
        }
        if (payAmt > 0) {
          this.show = true
        }
      })
    },

    methods: {
      goBack() {
        navigateBack()
      },
      // 去支付
      async goPay() {
        await submit(async $ => {
          await $.start()
          const payData = await apiOrderOrderPay({
            orderNo: this.queryParams.orderNo,
            payType: globalModel.state.payType,
            openId: globalModel.state.openid,
          })
          await dcb.requestPayment({
            provider: 'native',
            showNativeResultPage: false,
            params: payData,
          })
          await wait(1000)
          redirectTo('OrderPayResult')
          await $.success('支付成功')
        })
      },
    },
  })
</script>

<style lang="scss" module>
  .status {
    padding-top: 48px;
    text-align: center;
    .img {
      width: 44px;
      height: 44px;
      vertical-align: middle;
    }
    .text {
      margin-top: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 20px;
      color: #333333;
      line-height: 28px;
      font-style: normal;
    }
    .price {
      margin-top: 12px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #999999;
      line-height: 17px;
      font-style: normal;
      span {
        color: #ff0f19;
      }
    }
  }
  .main {
    width: 335px;
    margin: 40px auto 0;
    background: #f5f5f5;
    border-radius: 6px;
    padding: 14px 0;
    text-align: center;
    box-sizing: border-box;
    .tips {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 18px;
      color: #333333;
      line-height: 25px;
      font-style: normal;
      span {
        color: rgba(250, 53, 48, 1);
      }
    }
    .time {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 29px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #666666;
      font-style: normal;
    }
    .btn {
      margin: 30px auto 0;
      width: 224px;
      height: 50px;
      text-align: center;
      background: linear-gradient(
        137deg,
        #fa4234 0%,
        #fb222a 50%,
        #fe7049 100%
      );
      border-radius: 25px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #ffffff;
      line-height: 50px;
      font-style: normal;
    }
  }

  .back {
    margin: 30px auto 0;
    width: 224px;
    height: 50px;
    text-align: center;
    background: #16bbbf;
    border-radius: 25px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    line-height: 50px;
    font-style: normal;
  }

  .popup {
    width: 335px;
    box-sizing: border-box;
    height: 264px;
    background: #ffffff;
    border-radius: 12px;
    padding: 24px 21px;

    .step {
      display: flex;
      align-items: flex-start;
      padding-bottom: 28px;
      position: relative;
      &::before {
        position: absolute;
        top: 5px;
        left: 10px;
        display: block;
        content: '';
        width: 1px;
        height: 100%;
        background: #e9e9e9;
      }
      &.step1 {
        &::before {
          display: none !important;
        }
      }
      img {
        display: block;
        width: 19px;
        height: 19px;
        margin-top: 3px;
        margin-right: 10px;
        z-index: 100;
      }
      .desc {
        .totalPrice {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #333333;
          line-height: 25px;
          text-align: left;
          font-style: normal;
          span {
            color: #ff960a;
          }
        }
        .payAmt {
          margin-top: 4px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #666666;
          line-height: 20px;
          text-align: left;
          font-style: normal;
        }
        .surPrice {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #333333;
          line-height: 25px;
          text-align: left;
          font-style: normal;
          span {
            color: #fa3530;
          }
        }
      }
    }
    .pay {
      margin: 0 auto;
      width: 237px;
      height: 42px;
      background: linear-gradient(
        137deg,
        #fa4234 0%,
        #fb222a 50%,
        #fe7049 100%
      );
      border-radius: 21px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #ffffff;
      line-height: 42px;
      text-align: center;
      font-style: normal;
    }
    .order {
      margin-top: 12px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #fa3530;
      line-height: 20px;
      text-align: center;
      font-style: normal;
    }
  }
</style>
